import React from 'react';
import { Button, Icon, styled } from 'hyarchis-global';

interface OwnProps {
  allowMultiple?: boolean;
  addFiles: (files: File[]) => void;
}

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 0%;
  margin-top: 10px;
  width: 100%;
  height: 80%;
`;

export const AddFileButton = styled(Button)`
  && {
    width: 100%;
    height: 100%;
    font-size: ${(props) => props.theme.fonts.sizes.sm}px;
    color: ${(props) => props.theme.colors.primary};
    background: #fafafa;
    border: 1px dashed rgb(217, 217, 217);
    &:hover {
      color: ${(props) => props.theme.colors.primaryFaded(0.75)};
      background: #fafafa;
      border: 1px dashed #6654c4;
    }
    svg {
      vertical-align: -0.12em;
      margin-right: 8px;
    }
  }
`;

const DocumentUploadForm = ({ allowMultiple, addFiles }: OwnProps) => {
  const inputRef: React.RefObject<HTMLInputElement> = React.createRef();
  const onFileChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      addFiles([...event.target.files]);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  };

  const onSelectFileClick = () => {
    const input = inputRef.current;
    input!.click();
  };

  return (
    <StyledWrapper data-test-id='document-upload-form'>
      <input
        style={{ visibility: 'hidden', position: 'absolute' }}
        ref={inputRef}
        type='file'
        onChange={onFileChanged}
        multiple={allowMultiple}
      />
      <AddFileButton size='large' onClick={onSelectFileClick} data-test-id='add-file-button'>
        <Icon icon='plus' type='regular' size={25} />
      </AddFileButton>
    </StyledWrapper>
  );
};

export default React.memo(DocumentUploadForm);
